import React, { useState } from 'react';
import '../Styles/Login.css';


//const IP = "http://143.110.239.79:5010/"
const IP = "https://pepetoys-backend.mindnt.com.mx/api/"
//const IP = "http://localhost:5010/"

const Login = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await fetch(`${IP}auth/login?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (response.ok) {
                // Login exitoso
                localStorage.setItem('isAuthenticated', 'true');
                localStorage.setItem('username', data.data.username);
                localStorage.setItem('userId', data.data.user_id);
                onLoginSuccess();
            } else {
                // Login fallido
                setError(data.message || 'Usuario o contraseña incorrectos');
            }
        } catch (err) {
            setError('Error de conexión. Por favor, verifica que el servidor esté corriendo.');
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <div className="login-header">
                    <h1>Pepetoys</h1>
                    <p>Sistema de Gestión</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <label htmlFor="username">Usuario</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Ingresa tu usuario"
                            required
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Contraseña</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Ingresa tu contraseña"
                            required
                        />
                    </div>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        className="login-button"
                        disabled={loading}
                    >
                        {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                    </button>
                </form>

                <div className="login-footer">
                    <p>© 2024 Pepetoys - Todos los derechos reservados</p>
                </div>
            </div>
        </div>
    );
};

export default Login;
